import React, { useState } from "react";
import { FaCartPlus } from "react-icons/fa";
import Button from "../../../components/Button/Button";
import { toast } from "react-toastify";

const ArticleCard = ({
  id,
  nom,
  description,
  prix,
  taille,
  photo_url,
  addToCart,
  is_stockable,
  quantite_stock,
}) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  const handleAddToCart = () => {
    addToCart({
      id,
      nom,
      prix: parseFloat(prix),
      photo_url,
      description,
      is_stockable, // 🔹 Ajout de la gestion du stock
      quantite_stock, // 🔹 Ajout de la gestion de la quantité en stock
      taille: taille || "", // 🔹 Ajout de la taille (évite undefined)
    });

    toast.success(`"${nom}" ajouté au panier.`);
  };

  const formattedPrice = parseFloat(prix).toFixed(2);
  const isOutOfStock = is_stockable && quantite_stock === 0;

  return (
    <div className="border-slate-300 dark:border-slate-600 border-2 dark:bg-slate-500 bg-slate-300 shadow-md rounded-lg overflow-hidden flex flex-col min-h-[400px] font-satoshi relative">
      <img
        src={photo_url || "default_product.jpg"}
        alt={nom}
        className="w-full h-64 object-cover flex-shrink-0"
        onClick={() => openImageModal(photo_url || "/img/no-image.jpg")}
      />
      <div className="flex flex-col flex-grow p-4 justify-between">
        <div>
          <h3 className="text-lg font-bold text-gray-600 dark:text-slate-100">
            {nom}
          </h3>
          <p className="text-sm text-gray-600 dark:text-slate-300">
            {description}
          </p>
          {taille && (
            <p className="text-sm text-gray-600 dark:text-slate-300 mt-2">
              Taille : {taille}
            </p>
          )}
          {is_stockable && (
            <p className="text-sm text-gray-600 dark:text-slate-300 mt-2">
              Stock restant : {quantite_stock}
            </p>
          )}
          <div className="mt-2">
            <div className="flex items-center text-2xl dark:text-slate-300 font-bold text-primary">
              {formattedPrice} €
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center mt-4 space-y-2">
          {isOutOfStock ? (
            <button
              className="w-full bg-gray-600 text-white py-2 px-4 rounded-full text-sm"
              disabled
            >
              Stock épuisé
            </button>
          ) : (
            <Button
              text="Ajouter au panier"
              onClick={handleAddToCart}
              icon={FaCartPlus}
              className="w-full gap-2 text-sm"
              hoverLabel="Ajouter ce produit au panier"
            />
          )}
        </div>
        {/* Modale pour agrandir l'image seule */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
            onClick={closeImageModal}
          >
            <div className="relative">
              <img
                src={selectedImage}
                alt="Agrandissement"
                className="max-w-full max-h-[70vh] rounded-lg"
              />
              <button
                className="absolute top-2 right-2 text-white text-2xl"
                onClick={closeImageModal}
                aria-label="Fermer"
              >
                &times;
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticleCard;
